export enum DETAILS_TITLES {
  Schedules = "schedules",
  CompanyCards = "company cards"
}

export enum COMPANY_DETAILS_TABS {
  Details = "details",
  FileSync = "file sync",
  EmailTransfer = "email transfer"
}

export enum DETAILS_TITLE_AREA_OPTIONS {
  DeviceImei = "device imei",
  Driver = "driver",
  Name = "name",
  VehicleRegistrationNumber = "vrn"
}

export enum COMPANY_SETTINGS {
  AutoAssignVehicleRegistrationNumber = "autoAssignVrn",
  AutoInitialVehicleDownload = "autoInitialVehicleDownload",
  AutoAssignGlobalScheduleToVehicle = "autoAssignGlobalScheduleToVehicle",
  AutomaticDriverRegistrationEnabled = "automaticDriverRegistrationEnabled",
  AutoDriverFileDownload = "autoDriverFileDownload",
  AutoAssignGlobalScheduleToDriver = "autoAssignGlobalScheduleToDriver",
  OverDraftEnabled = "overDraftEnabled",
  OverDraftAmount = "overDraftAmount" // this must be changed to the real property, when it is done in BE
}

export enum CREDITS_OVERDAFT_LIMITS {
  Min = 1,
  Max = 10000
}
